import {initializeMasteryScore} from "./initializeMasteryScore";

export function CourseBase( masteryScore ){

    let bSequenceOpen = false;
    const nCourseMasteryScore = initializeMasteryScore( masteryScore );

    // revealing public api
    return {

        /**
         * @returns the course mastery score
         */
        getCourseMasteryScore: function () {
            return nCourseMasteryScore;
        },

        setSequenceOpened: function () {
            bSequenceOpen = true;
        },

        setSequenceClosed : function () {
            bSequenceOpen = false;
        },

        isSequenceOpen: function () {
            return bSequenceOpen;
        }
    };
}
